/* eslint-disable no-loop-func */
import { MaxFlowProblem } from '../typings';
import { augmentCapacityAlongPath } from './helpers';

const { min } = Math;

export function stepEdmondsKarp(
  problem: MaxFlowProblem,
  distanceLabels: number[],
  qGoldbergTarjan: number[],
  curEdge: number,
  xf: number[],
  initDone: boolean,
  qHead: number,
  qTail: number
): [
  MaxFlowProblem,
  boolean,
  number[],
  boolean[][],
  boolean[][],
  number[],
  number[],
  number,
  number[],
  boolean,
  number,
  number
] {
  // Find augmented path with BFS
  const q = [problem.source];
  const visited: boolean[] = [];
  visited[problem.source] = true;
  const parents: number[] = [];
  let u = -1;
  let foundAugmentingPath = false;
  while (q.length > 0) {
    u = q.shift() as number;
    if (u === problem.target) {
      foundAugmentingPath = true;
      break;
    } else {
      for (const v of problem.graph.cachedTargetKeys[u]) {
        if (!visited[v] && problem.graph.edges[u][v].residualCapacity > 0) {
          visited[v] = true;
          parents[v] = u;
          q.push(v);
        }
      }
    }
  }

  // Reconstruct path
  let minResidualCapacity = Infinity;
  const path = [u];
  if (foundAugmentingPath) {
    while (u !== problem.source) {
      path.unshift(parents[u]);
      minResidualCapacity = min(
        minResidualCapacity,
        problem.graph.edges[parents[u]][u].residualCapacity
      );
      u = parents[u];
    }
  }

  return [
    foundAugmentingPath ? augmentCapacityAlongPath(problem, path, minResidualCapacity) : problem,
    !foundAugmentingPath,
    path,
    [],
    [],
    [],
    [],
    0,
    [],
    false,
    0,
    0
  ];
}
